// eslint-disable-next-line import/prefer-default-export
export async function performSearch({
  searchUrl,
  csrfToken,
  errorId,
  traceId,
  timeRange,
}) {
  const response = await fetch(searchUrl, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({
      error_id: errorId,
      trace_id: traceId || null,
      time_range: timeRange,
    }),
  });

  if (response.status === 401) {
    window.location.reload();
    return null;
  }

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Search failed.');
  }

  return data;
}
